<!-- =========================================================================================
    File Name: tableFilterSorter.vue
    Description: Add filter and sorting functionality to table
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <b-overlay
    :show="show"
    :variant="variant"
    :opacity="opacity"
    :blur="blur"
    rounded="lg"
    spinner-variant="primary"
  >
    <b-card>
  
      <div class="heading vx-row">
        <div class="vx-col w-1/2">
          <span class="h4">{{ $t("Departments") }}</span>
          <feather-icon
            id="export"
            icon="DownloadCloudIcon"
            svgClasses="w-5 h-5 hover:text-danger stroke-current"
            class="ml-5"
            :title="$t('Export')"
            v-b-modal.modal-1
          />
        </div>
        <div class="vx-col w-1/2" v-if="roles=='admin'">
          <div class="flex float-right walk-card">
            <b-form-checkbox
              v-model="showDirectDepartment"
              size="lg"
              name="cell_width"
              switch
              @change="getDepartments()"
            >
            </b-form-checkbox>

            <!-- <vs-switch v-model="" /> -->
            <span class="float-right ml-3">{{
              $t("ShowDirectDepartment")
            }}</span>
          </div>
        </div>
      </div>

      <b-modal
        id="modal-1"
        :title="$t('ExportToExcel')"
        :ok-title="$t('Export')"
        :cancel-title="$t('Cancel')"
        @ok="exportToExcel"
        @cancel="clearFields"
        @close="clearFields"
        class="export-options"
        centered
      >
        <b-input
          v-model="fileName"
          :placeholder="$t('FileName')"
          class="w-full"
        />
        <v-select v-model="selectedFormat" :options="formats" class="my-4">
          <template v-slot:option="option">
            <span :class="option.icon">{{ option.label }} </span>
            <feather-icon
              v-if="selectedFormat == option.label"
              icon="CheckIcon"
              class="float-right"
              svgClasses="w-5 h-5"
            />
          </template>
        </v-select>
        <div class="flex walk-card">
          <span class="mr-4">{{ $t("CellAutoWidth") }}:</span>
          <b-form-checkbox
            v-model="cellAutoWidth"
            size="lg"
            name="cell_width"
            switch
          >
          </b-form-checkbox>
        </div>
      </b-modal>

      <div class="export-table mt-10">
        <div class="w-1/2" v-if="roles=='admin'">
          <b-button
            variant="primary"
            type="filled"
            class="br-20 add btn-primary:focus"
            @click="$router.push('/company/department/add').catch(() => {})"
            >{{ $t("Add") }}</b-button
          >
        </div>
        <b-col lg="5" class="w-1/2 float-right"  v-if="roles=='admin'">
          <b-form-group
            label-for="filter-input"
            label-cols-sm="3"
            label-align-sm="right"
            label-size="sm"
            class="mb-5"
          >
            <b-input-group size="md">
              <b-input-group-prepend is-text>
                <b-icon icon="search"></b-icon>
              </b-input-group-prepend>
              <b-form-input
                id="filter-input"
                v-model="filter"
                type="search"
                :placeholder="$t('Search')"
              ></b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-table
          :current-page="currentPage"
          :per-page="perPage"
          :items="departments"
          :fields="fields"
          :busy="isBusy"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          responsive
          show-empty
          :filter="filter"
          :filter-included-fields="filterOn"
          :empty-text="$t('EmptyData')"
          :empty-filtered-text="$t('EmptyFilter')"
          @filtered="onFiltered"
        >
          <template #head()="data">
            <span>{{ $t(data.label) }}</span>
          </template>
          <template #cell(action)="data">
            <feather-icon
              v-b-tooltip.hover
              :title="
                data.item.visiblity_status
                  ? $t('RemoveVisibility')
                  : $t('SetVisibility')
              "
              @click="changeVisiblity(data.item.visiblity_status, data.item.id)"
              icon="StopCircleIcon"
              svgClasses="w-5 h-5 hover:text-danger stroke-current"
              class="ml-2"
            />
            <feather-icon
              v-b-tooltip.hover
              :title="$t('Edit')"
              icon="EditIcon"
              svgClasses="w-5 h-5 hover:text-danger stroke-current"
              class="ml-2"
              @click.prevent="$router.push({name:'Company-department-update', params: {id:data.item.id}})"
            />
            <feather-icon
              v-b-tooltip.hover
              :title="$t('Delete')"
              icon="TrashIcon"
              svgClasses="w-5 h-5 hover:text-danger stroke-current"
              class="ml-2"
              @click="deleteStaff(data.item.id)"
            />
            <feather-icon
              v-if="is_unio == 1"
              v-b-tooltip.hover
              :title="$t('TimeSlot')"
              icon="ClockIcon"
              svgClasses="w-5 h-5 hover:text-danger stroke-current"
              class="ml-2"
              @click="
                $router.push('/company/department/timeslot/' + data.item.id)
              "
            />
            
            <feather-icon
              v-b-tooltip.hover
              :title="$t('BookingForm')"
              icon="FileTextIcon"
              svgClasses="w-5 h-5 hover:text-danger stroke-current"
              class="ml-2"
              @click="
                $router.push('/company/settings/appbookingform/' + data.item.id)
              "
            />
            <template v-if="roles=='admin' || data.item.staff_user_id == currentUser.staff_id">
              <feather-icon
                v-b-tooltip.hover
                :title="$t('TimeSlot')"
                icon="ClockIcon"
                svgClasses="w-5 h-5 hover:text-danger stroke-current"
                class="ml-2"
                @click="$router.push({name:'department-ordinary-slug', params: {id:data.item.id}})"
              />
              <feather-icon
                v-b-tooltip.hover
                :title="$t('Exceptions')"
                icon="WatchIcon"
                svgClasses="w-5 h-5 hover:text-danger stroke-current"
                class="ml-2"
                @click="$router.push({name:'department-exception-slug', params: {id:data.item.id}})"
              />
            </template>
          </template>
        </b-table>
        <b-pagination
          v-if="rows > perPage"
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          aria-controls="my-table"
          class="float-right"
        ></b-pagination>
      </div>
    </b-card>
  </b-overlay>
</template>

<script>
import vSelect from "vue-select";
import TableSSRVue from "../../../../jail-app/src/views/ui-elements/table/TableSSR.vue";
export default {
  components: {
    vSelect,
  },
  data() {
    return {
      fileName: "",
      formats: ["xlsx", "csv", "txt"],
      cellAutoWidth: true,
      selectedFormat: "xlsx",
      headerTitle: ["Department", "Description", "BookingMessage", "Duration"],
      headerVal: [
        "department_name",
        "description",
        "booking_message",
        "duration",
      ],
      departments: [],
      activePrompt: false,
      showDirectDepartment: false,
      show: false,
      variant: "light",
      opacity: 0.85,
      blur: "2px",
      error: "",
      success: "",
      sec: 2,
      counter: 0,
      perPage: 10,
      currentPage: 1,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      isBusy: false,
      totalRows: 1,
      fields: [
        {
          key: "department_name",
          label: "Department",
          sortable: true,
          sortDirection: "desc",
        },
        { key: "action", label: "Action" },
      ],
      roles:""
    };
  },
  computed: {
    currentUser() {
      return this.$store.getters.currentUser;
    },
    is_unio() {
      return this.$store.getters.currentUser.is_unio;
    },
    rows() {
      return this.departments.length;
    },
  },
  created() {
    this.roles=this.$store.getters.roles;
    this.getDepartments();
  },
  methods: {
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    /**
     *  exportToExcel method for export file according to format
     **/
    exportToExcel() {
      import("@/assets/utils/export").then((excel) => {
        const list = this.departments;
        this.headerTitle.map((title, index) => {
          this.headerTitle[index] = this.$t(title);
        });

        const data = this.formatJson(this.headerVal, list);
        excel.export_json_to_excel({
          header: this.headerTitle,
          data,
          filename: this.fileName,
          autoWidth: this.cellAutoWidth,
          bookType: this.selectedFormat,
        });
        this.headerTitle = [
          "Department",
          "Description",
          "BookingMessage",
          "Duration",
        ];
        this.clearFields();
      });
    },
    /**
     *  @params filterVal ,jsonData
     * formatJson   method  for export file according to format
     **/
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) =>
        filterVal.map((j) => {
          return v[j];
        })
      );
    },
    /**
     *
     * clearFields   method  for export selected format
     **/

    clearFields() {
      this.fileName = "";
      this.cellAutoWidth = true;
      this.selectedFormat = "xlsx";
    },
    /**
     *
     * getDepartments   method  for list all departments data
     **/
    getDepartments() {
      this.show = true;
      console.log("showDirectDepartment", this.showDirectDepartment);
      let role=this.$store.getters.roles; 
      var data = {
        company_id: role == "assistant" ? this.$store.getters.currentUser.company_id : this.$store.getters.currentUser.id,
        direct_filter: this.showDirectDepartment,
      };
      let action=role == 'staff' ? 'StaffDepartmentsWithFilter':'DepartmentsWithFilter';
      this.$store
        .dispatch(action, data)
        .then((res) => {
          this.show = false;
          console.log("test",res);
          this.departments = res.data.data;
          this.totalRows = this.departments.length; 
        })
        .catch((error) => {
          this.$log.error(
            "File : List.vue | Function : getDepartments() | Error :",
            error
          );
          this.show = false;
          // Error response
          this.error =
            this.$t(error.replace(/[\s\/]/g, "")) !==
            error.replace(/[\s\/]/g, "")
              ? this.$t(error.replace(/[\s\/]/g, ""))
              : error;
          this.$toasted.show(this.error, {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });
          return false;
        });
    },
    /**
     *
     * deleteStaff   method  for delete  department from listing
     **/
    deleteStaff(id) {
      this.$swal({
        title: this.$t("DeleteDepartmentMessage"),

        type: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("Yes"),
        confirmButtonColor: "#7367F0",
        cancelButtonText: this.$t("No"),
        showCloseButton: true,
        showLoaderOnConfirm: true,
      })
        .then((result) => {
          if (result.value) {
            this.show = true;
            this.departments.id = id;
            this.$store.dispatch("Deletedep", this.departments).then((res) => {
              this.show = false;
              this.getDepartments();
              this.$toasted.show(this.$t("DepartmentDeleted"), {
                className: "top-alert",
                position: "top-center",
                type: "success",
                duration: 2000,
              });
            });
          }
        })
        .catch((error) => {
          this.$log.error(
            "File : List.vue | Function : deleteStaff() | Error :",
            error
          );
          this.show = false;
          // Error response
          this.error =
            this.$t(error.replace(/[\s\/]/g, "")) !==
            error.replace(/[\s\/]/g, "")
              ? this.$t(error.replace(/[\s\/]/g, ""))
              : error;
          this.$toasted.show(this.error, {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });
          return false;
        });
    },
    /**
     * open popup
     */
    changeVisiblity(value, id) {
      var data = {
        id: id,
        visiblity_status: !value,
      };
      this.$store
        .dispatch("ChangeVisiblity", data)
        .then((res) => {
          this.show = false;
          this.getDepartments();

          this.$toasted.show(this.$t("VisiblityUpdated"), {
            className: "top-alert",
            position: "top-center",
            type: "success",
            duration: 2000,
          });
        })
        .catch((error) => {
          this.$log.error(
            "File : Form.vue | Function : updateRooms() | Error :",
            error
          );
          this.show = false;
          // Error response
          this.error =
            this.$t(error.replace(/[\s\/]/g, "")) !==
            error.replace(/[\s\/]/g, "")
              ? this.$t(error.replace(/[\s\/]/g, ""))
              : error;
          this.$toasted.show(this.error, {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });
          return false;
        });
    },
  },
};
</script>

<style scoped>
.heading {
  margin-bottom: 20px;
}

@media only screen and (min-width: 280px) and (max-width: 500px) {
 .heading .w-1\/2 {
    width: 100% !important;
    margin-bottom: 20px;
  }
}

.add {
  position: absolute;
  margin-bottom: 20px;
}

@media only screen and (max-width: 600px) {
  .add {
    position: absolute;
    margin-top: 10px;
  }
}

.action {
  margin-left: 20px;
  display: inline;
}

.con-vs-tooltip {
  display: inline;
}
</style>